<template>
  <div class="row">
    <div class="col-md">
      <h5>Prozess Starter</h5>
      <div class="form-group">
        <label>Prozess-ID</label>
        <select v-model="newprocid" class="form-control">
          <option v-for="pd in procdefs" :key="pd.id" :value="pd.key">{{ pd.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>Name / Bezeichnung</label>
        <input type="text" v-model="newname" class="form-control"/>
      </div>
      <div class="btn-toolbar">
        <button @click="addStarter" class="btn btn-primary"><font-awesome-icon icon="plus"/>&nbsp;Hinzufügen</button>
      </div>
      <hr/>
      <h5>Aktuelle Starterauswahl</h5>
      <ul class="list-group">
        <li class="list-group-item d-flex justify-content-between" v-for="(st,idx) in startlist" :key="st.name">
          <span>{{ st.name }}</span>
          <span><i>{{ st.procid }}</i></span>
          <button @click="deleteStarter(idx)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
        </li>
      </ul>
      <hr class="m-2"/>
      <h5>Laufende Aufgaben</h5>
      <ul class="list-group-item">
        <li class="list-group-item d-flex justify-content-between" v-for="t in tasks" :key="t.id">
          {{ t.name }}
          <small>{{ t.created }}</small>
        </li>
      </ul>
    </div>
    <div class="col-md">
      <h5>Benutzer Aktionen (Events)</h5>
      <div class="form-group">
        <label>Event Auswahl</label>
        <select v-model="neweventid" class="form-control">
          <option v-for="(e,idx) in eventdefs" :key="idx" :value="e.id">
            <span>{{ e.name }}</span>
          </option>
        </select>
      </div>
      <div class="form-group">
        <label>Name / Bezeichnung</label>
        <input type="text" v-model="newevent" class="form-control"/>
      </div>
      <div class="btn-toolbar">
        <button @click="addEventStarter" class="btn btn-primary"><font-awesome-icon icon="plus"/>&nbsp;Hinzufügen</button>
      </div>
      <hr/>
      <!-- TODO make extra history tab in user view for process and event starts -->
      <h5>Aktuelle Benutzer Events</h5>
      <ul class="list-group">
        <li v-for="(es,idx) in estartlist" :key="idx" class="list-group-item d-flex justify-content-between">
          <span>{{ es.name }} ({{ es.id }})</span>
          <button class="btn btn-danger float-right" @click="deleteEventStarter(idx)"><font-awesome-icon icon="trash"/></button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import workflows from '@/modules/workflows.js'
import services from '@/modules/services.js'
import bflows from '@/modules/bflows.js'

export default {
  name: 'UserTaskEditor',
  props: ['userid'],
  data() {
    return {
      role: '',
      tasks: [],
      procdefs: [],
      startlist : [],
      eventdefs: [],
      estartlist: [],
      newprocid: '',
      newname: '',
      newevent: '',
      neweventid: '',
    }
  },
  created: function() {
    var self = this;
    workflows.definitions(this,function(data) {
      self.procdefs = data;
    })
    bflows.listbaseevents(this,'user',function(data) {
      self.eventdefs = data;
    });
    this.fetchData();
  },
  methods: {
    fetchData: function(role) {
      var self = this;
      services.startlist(this,this.userid,function(data) {
        self.startlist = data;
      })
      bflows.listusertrigger(this,this.userid,function(data) {
        self.estartlist = data;
      });
      console.log("role: " + role);
      if (role && role !== '') {
        this.role = role;
        services.tasklist(this,this.role,function(data) {
          self.tasks = data;
        })
      }
    },
    save: function() {
      var cfg = {};
      cfg['if.workflow.process.start.list.' + this.userid] = JSON.stringify(this.startlist);
      cfg["if.bflows.start.list." + this.userid]           = JSON.stringify(this.estartlist);
      console.log(cfg);
      var self = this;
      config.savecfg(cfg,this,function() {
        self.$bvToast.toast('Startliste aktualisiert.',{title:'Prozess Starter',variant: 'success'});
      })
    },
    addEventStarter: function() {
      this.estartlist.push({name: this.newevent, id: this.neweventid });
      this.save();
    },
    deleteEventStarter: function(idx) {
      this.estartlist.splice(idx,1);
      this.save();
    },
    addStarter: function() {
      this.startlist.push({name: this.newname, procid: this.newprocid});
      this.save();
    },
    deleteStarter: function(idx) {
      this.startlist.splice(idx,1);
      this.save();
    },
  }
}
</script>
